import React from "react";

export const ClientUi = props => (
  <div className="client-ui">{props.children}</div>
);
